<template>
  <div class="page-layout">
    <header class="border-bottom" v-if="isNativeApp === false">
      <b-container fluid>
        <b-row>
          <b-col>
            <header-campaigns v-if="isCampaignsEnabled"/>
            <header-im v-else-if="isNewHeader"/>
            <header-mentorship v-else-if="$root.isOnlyMentorship"/>
            <header-block v-else/>
          </b-col>
        </b-row>
      </b-container>
    </header>

    <!-- b-container v-if="statuses.length">
      <status-bar v-for="(status, i) in statuses" :key="i" class="m-2" :status="status"/>
    </b-container -->

    <b-container fluid>
      <b-row>
        <b-col>
          <slot :companyID="companyID"/>
        </b-col>
      </b-row>
    </b-container>

    <footer>
      <footer-block/>
    </footer>

    <no-ssr v-if="company && company.siteBranding">
      <cookie-law theme="base" v-if="!isNativeApp && !company.siteBranding.disableCookieWarning">
        <b-container fluid slot-scope="props" style="max-width: 1600px; margin: 0 auto;">
          <b-row>
            <b-col style="display: flex; justify-content: center; align-items: center;"><p>{{ $t('variables.cookie-message') }}</p></b-col>
            <b-col style="display: flex; justify-content: center; align-items: center;"><b-button variant="primary" @click="props.accept"><span>{{ $t('variables.cookie-button') }}</span></b-button></b-col>
          </b-row>
          <b-row v-if="company.siteBranding.customFooterHTML" class="custom-footer-html" v-html="company.siteBranding.customFooterHTML"/>
        </b-container>
      </cookie-law>
    </no-ssr>
  </div>
</template>

<script>
import CookieLaw from 'vue-cookie-law';
import HeaderBlock from '@/components/Header';
import HeaderIm from '@/components/HeaderIM';
import HeaderCampaigns from '@/components/HeaderCampaigns';
import HeaderMentorship from '@/components/HeaderMentorship';
import FooterBlock from '@/components/Footer-minimal';
import { getStatusesForRoute } from '@/lib/status';
import { mapRoot, mapPreferences } from '@/mixins/root';
import { StatusBar } from '@src/components/Statuses';

export default {
  name: 'MainLayout',
  components: {
    CookieLaw,
    HeaderBlock,
    FooterBlock,
    HeaderIm,
    HeaderCampaigns,
    HeaderMentorship,
    StatusBar,
  },
  mounted() {
    // Redirect Expd8 to new platform
    if (this.$root.isEXPD8 && process.env.VUE_ENV === 'client' && !this.$root.isSuperAdmin) {
      window.location.href = 'https://default.expd8rewards.reallinks.app';
    }

    // Redirect ERM to new platform
    if (this.$root.isERM && process.env.VUE_ENV === 'client' && !this.$root.isSuperAdmin) {
      window.location.href = 'https://default.erm.reallinks.app';
    }

    // Redirect BT to new platform
    if (this.$root.isBT && process.env.VUE_ENV === 'client' && !this.$root.isSuperAdmin) {
      window.location.href = 'https://default.bt.reallinks.app';
    }

    // Redirect Optiver Interns to new platform
    if (this.$root.isOptiverInterns && process.env.VUE_ENV === 'client' && !this.$root.isSuperAdmin) {
      window.location.href = 'https://default.optiver.reallinks.app';
    }

    // Redirect Capco to new platform
    if (this.$root.isCapco && process.env.VUE_ENV === 'client' && !this.$root.isSuperAdmin) {
      window.location.href = 'https://default.capco.reallinks.app';
    }

    // Redirect Idiada to new platform
    if (this.$root.isApplusIdiada && process.env.VUE_ENV === 'client' && !this.$root.isSuperAdmin) {
      window.location.href = 'https://default.idiada.reallinks.app';
    }
  },
  computed: {
    ...mapRoot([ 'company', 'isNativeApp', 'isOnlyMentorship' ]),
    ...mapPreferences([ 'isNewHeader', 'isCampaignsEnabled' ]),
    companyID() {
      return this.company ? this.company.id : null;
    },
    statuses() {
      return getStatusesForRoute(this.$route).filter(status => status && status.type === 'bar');
    },
  },
};
</script>

<style lang="scss">
.page-layout {
  > .container, > .container-fluid, header > .container, .container-fluid {
    // min-height: 100%;
    position: relative;
    width: 100%;

    margin: 0 auto 0 auto;
    max-width: 1600px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/Main.vue